import { render, staticRenderFns } from "./reg-done.vue?vue&type=template&id=ba79ee94&lang=pug&"
import script from "./reg-done.vue?vue&type=script&lang=js&"
export * from "./reg-done.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports